import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/masters/country/${id}`);
    reset(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
  try {
    // Build payload for edit
    const payload = {
      ...data,
      id: id, // main country id
      count: countLang.map((lang, index) => ({
        ...lang,
        name: data[lang.id], // overwrite with updated values
        country_id: id,      // keep country_id
        language_id: lang.language_id || lang.id, // ensure language id stays
      })),
    };

    console.log("Edit Payload:", payload);

    const response = await postData(`/masters/country/${id}`, payload);

    if (response?.success) {
      setShowModal({ code: response.code, message: response.message });
    } else {
      setShowModal({ code: response.code, message: response.message });
    }

    setTimeout(() => {
      setShowModal(0);
      props.handleClose();
    }, 1000);
  } catch (error) {
    console.log(error);
  }
};


  const [countLang, setCountLang] = useState([]);
  
    const getLanguges = async () => {
      const response = await getData("/all-languages");
      setCountLang(response.data);
    };
  
    useEffect(() => {
      getLanguges();
    }, []);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Country
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="justify-content-center">

            {countLang?.map((lang, index) => (
                <Col md={12} key={lang.id}>
                  <div className="main-form-section mt-5">
                    <Row className="justify-content-center">
                      <Form.Label column sm={3}>
                        Country Name ({lang?.name})
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control
                              type="text"
                              placeholder={`Enter country name in ${lang?.name}`}
                              className="input-mandatory"
                              {...register(`${lang.id}`, {
                                required: `Country name is required in ${lang.name}`,
                              })}
                            />
                          </InputGroup>
                          {errors[lang.id] && (
                            <span className="text-danger">
                              {errors[lang.id].message}
                            </span>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ))}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
